export default __webpack_public_path__ + "static/media/sliderAme1.d2da2375.jpg";